import {
  Container,
  Box,
  Alert,
  LinearProgress,
  Typography,
  Tab,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from '@mui/material';
import { useParams, useSearchParams } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import React from 'react';
import { MerchantType } from '../../../interfaces/delivery-company/merchants';
import axios, { AxiosResponse } from 'axios';
import { AuthContext } from '../../../contexts/user-context/user-context';
import { API_ENDPOINT } from '../../../configurations/global.config';
import CreateMerchantForm from '../merchants/merchant-forms/create-or-edit-merchant';
import InventoryIcon from '@mui/icons-material/Inventory';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import ListAltIcon from '@mui/icons-material/ListAlt';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import MerchantOrders from './merchant-orders';
import { IconWithText } from '../../common/styles/components';
import { TabContext, TabPanel } from '@mui/lab';
import MerchantPickups from './merchant-pickups';
import MerchantInvitation from '../merchants/merchant-forms/merchant-invite';
import TabsLayout from '../../common/tabs-layout/tabs-layout';

function Merchant() {
  const { merchantId } = useParams();

  
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [merchant, setMerchant] = useState<MerchantType>();
  const [response, setResponse] = useState<AxiosResponse>();
  const [message, setMessage] = useState<string>('');
  const { config } = useContext(AuthContext);


  React.useEffect(() => {
    const getAndSetMerchant = async () => {
      if (merchantId !== undefined) {
        setIsLoading(true);
        try {
          const endpoint = `${API_ENDPOINT}/api/v1/merchant/${merchantId}/`;

          console.log(endpoint);
          const response = await axios.get<MerchantType>(endpoint, config);
          console.log(response);
          setResponse(response);
          setMerchant(response.data);
        } catch (e) {
          setMerchant(undefined);
          if (axios.isAxiosError(e)) {
            setMessage('Failed to load merchant data: ' + e.message);
          } else {
            setMessage('Failed to load merchant data');
          }
          console.log(e);
        }
        setIsLoading(false);
      }
    };
    getAndSetMerchant();
  }, []);

  if (merchantId === undefined)
    return <Alert severity="error">Invalid Merchant Id</Alert>;
  return (
    <div>
      <Typography
        variant="h3"
        component="h3"
        sx={{ textAlign: 'center', mt: 3, mb: 3, marginBottom: 0 }}
      >
        Merchant
      </Typography>

      {merchant && (
        <Typography
          variant="h5"
          component="h5"
          sx={{ textAlign: 'center', mt: 3, mb: 3, marginTop: 0 }}
        >
          {merchant.name} <br /> {merchant.phone_number}

          <Box mt={1} display={"flex"} justifyContent={"center"}>
             <MerchantInvitation connected={merchant.has_usable_password} initializationAttempted={merchant.initialization_attempted ?? false} merchantId={merchant.id } onSuccess={()=>setMerchant({...merchant, initialization_attempted: true})} />
          </Box>
       
        </Typography>
      )}

      <Box>
        {isLoading && <LinearProgress />}

        {message !== '' && (
          <Alert
            severity={
              response && response.status >= 200 && response.status < 300
                ? 'success'
                : 'error'
            }
          >
            {message}
          </Alert>
        )}

        {!isLoading && merchant && (
            <Box sx={{ width: '100%', typography: 'body1' }}>
             <TabsLayout 
                source={"merchant-page-layout"}
                orientation='horizontal'
                sections={[
                  {
                    label: 'Orders',
                    content:  <MerchantOrders merchant={merchant} />,
                    icon:  <InventoryIcon color="primary" />
                  },
                  {
                    label: 'Pickups',
                    content:   <MerchantPickups merchant={merchant} />,
                    icon:  <ListAltIcon color="primary" />
                  },
                  {
                    label: 'Account',
                    content: <CreateMerchantForm
                                defaultMerchant={merchant}
                                headless={true}
                              />,
                    icon:  <AccountBoxIcon color="primary" />
                  },
                ]}
            />
            </Box>
        )}
      </Box>
    </div>
  );
}

export default Merchant;
